import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import signup from "@/store/modules/signup";
import password from "@/store/modules/password";
import chat from "@/store/modules/chat";

const store = new Vuex.Store({
    modules: {
        auth,
        signup,
        password,
        chat
    }
});

export default store;